import { css } from 'linaria';
import { styled } from 'linaria/react';
import { mediaSmallDesk, mediaTablet, mediaMobile } from 'utils/internal-specifics/media-queries';

export const ReviewsContentPdp = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopSide = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 230px;

  ${mediaSmallDesk} {
    flex-basis: 180px;
  }

  ${mediaTablet} {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 100%;
  }

  ${mediaMobile} {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 100%;
  }
`;

export const BottomSidePdp = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  @media (--only-mobile) {
    margin: 0 var(--space-200);
  }
`;

export const sectionSubtitle = css`
  display: block;
  margin-bottom: var(--space-350);
`;

export const reviewsSectionContainer = css`
  padding-bottom: var(--space-1000);

  @media (--only-mobile) {
    padding-top: var(--space-500);
  }

  @media (--to-tablet) {
    margin-top: 0;
  }

  @media (--from-desktop) {
    padding-bottom: var(--space-500);
  }
`;

const addNewButtonContainer = css`
  @media (--only-mobile) {
    margin-top: var(--space-350);
  }
`;

const ratingsContainer = css`
  width: 100%;
`;

export const sortDropdown = css`
  margin-bottom: var(--space-275);
`;

export const TopSideGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 197px;
  grid-row-gap: var(--space-300);
  margin-bottom: var(--space-275);

  @media (--to-tablet) {
    display: flex;
    flex-direction: column;
    align-items: start;
    & > * {
      width: 100%;
    }
    & > div:first-child {
      order: 0;
    }
    .${addNewButtonContainer} {
      order: 1;
      a {
        width: 100%;
      }
    }
    .${ratingsContainer} {
      order: 2;
    }
  }
  @media (--from-tablet) {
    margin-bottom: var(--space-450);
  }
`;

export const Controls = styled.div`
  @media (--from-tablet) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-275);
  }
`;

export const additionalTitleMargin = css`
  margin-bottom: var(--space-150);
`;
